function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import './ChooseMonth.css';
import React from 'react';
import { celsiusToFahrenheit } from '../../utils';
var ChooseMonth = function ChooseMonth(_ref) {
  var months = _ref.months,
    title = _ref.title,
    selectedMonthId = _ref.selectedMonthId,
    fahrenheitLabel = _ref.fahrenheitLabel,
    celsiusLabel = _ref.celsiusLabel,
    onMonthClick = _ref.onMonthClick;
  return /*#__PURE__*/React.createElement("div", {
    className: commonStyles
  }, /*#__PURE__*/React.createElement("h3", {
    className: "choose-month__title"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "choose-month__wrapper"
  }, months.map(function (month) {
    return /*#__PURE__*/React.createElement(MonthItem, _extends({
      onClick: function onClick() {
        return onMonthClick && onMonthClick(month.id);
      },
      isSelected: selectedMonthId === month.id,
      key: month.monthName,
      fahrenheitLabel: fahrenheitLabel,
      celsiusLabel: celsiusLabel
    }, month));
  })));
};
export default ChooseMonth;
var commonStyles = "c1uyvyyz";
var MonthItem = function MonthItem(_ref2) {
  var id = _ref2.id,
    monthName = _ref2.monthName,
    temperature = _ref2.temperature,
    weatherIcon = _ref2.weatherIcon,
    isSelected = _ref2.isSelected,
    fahrenheitLabel = _ref2.fahrenheitLabel,
    celsiusLabel = _ref2.celsiusLabel,
    onClick = _ref2.onClick;
  return /*#__PURE__*/React.createElement("label", {
    htmlFor: id,
    className: "month-item ".concat(commonMonthItemStyles, " ").concat(isSelected ? "month-item__selected" : "")
  }, /*#__PURE__*/React.createElement("input", {
    className: "month-item__hidden-radio",
    id: id,
    type: "radio",
    checked: isSelected,
    onChange: onClick
  }), /*#__PURE__*/React.createElement("div", {
    "aria-hidden": true,
    className: "month-item__weather-icon",
    dangerouslySetInnerHTML: {
      __html: weatherIcon
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "month-item__info"
  }, /*#__PURE__*/React.createElement("div", {
    className: "month-item__name"
  }, monthName), /*#__PURE__*/React.createElement("div", {
    className: "month-item__temperature"
  }, /*#__PURE__*/React.createElement("span", {
    className: "month-item__tc"
  }, temperature, celsiusLabel), /*#__PURE__*/React.createElement("span", {
    className: "month-item__tf"
  }, celsiusToFahrenheit(temperature), fahrenheitLabel))));
};
var commonMonthItemStyles = "c14w105i";